module.exports = __webpack_public_path__ + "img/veto_juli.e3693da0.jpg";